import React from 'react';
import { styled } from '@mui/material/styles';

import { getPasswordStrengthPercentage } from '../../../Utils/Password';

const Container = styled('div')(({ theme }: any) => ({
  height: theme.spacing(1),
  backgroundColor: theme.palette.action.hover,
}));

const Progress = styled('div')(({ theme, percentage }: any) => ({
  borderRadius: theme.shape.borderRadius,
  background: `linear-gradient(90deg, rgba(244,67,54,1) 0%, rgba(255,152,0,1) 25%, rgba(255,235,59,1) 50%, rgba(211,198,3,1) 75%, rgba(76,175,80,1) 100%)`,
  height: theme.spacing(1),
  width: '100%',
  transition: 'clip-path 0.7s',
  clipPath: `inset(0 ${100 - percentage}% 0 0)`,
}));

function PasswordStrengthProgress({ password }: any) {
  const percentage = getPasswordStrengthPercentage(password);

  return (
    <Container>
      <Progress percentage={percentage} />
    </Container>
  );
}

export default PasswordStrengthProgress;
